import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import client from '../api/client';

const PLAN_COLOR: Record<string, string> = {
  free: '#8892A4', basic: '#00D4AA', standard: '#378ADD', pro: '#F6AD55'
};
const PLAN_PRICE: Record<string, string> = {
  free: '무료', basic: '월 13,900원', standard: '월 19,900원', pro: '월 29,900원'
};

export default function MyPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user') || '{}'));
  const [tab, setTab] = useState<'plan' | 'password' | 'email' | 'withdraw'>('plan');
  const [pwForm, setPwForm] = useState({ current: '', next: '', confirm: '' });
  const [pwMsg, setPwMsg] = useState('');
  const [emailSettings, setEmailSettings] = useState({ email_rank_report: true, email_notice: true });
  const [emailMsg, setEmailMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [subStatus, setSubStatus] = useState<any>(null);

  useEffect(() => {
    client.get('/payment/billing/status').then(r => setSubStatus(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    client.get('/auth/email-settings').then(r => setEmailSettings(r.data)).catch(() => {});
    // 서버에서 최신 플랜 정보 조회
    client.get('/auth/me').then(r => {
      const updated = { ...user, ...r.data };
      setUser(updated);
      if (localStorage.getItem('user')) localStorage.setItem('user', JSON.stringify(updated));
      else sessionStorage.setItem('user', JSON.stringify(updated));
    }).catch(() => {});
  }, []);

  const handlePwChange = async () => {
    if (pwForm.next !== pwForm.confirm) return setPwMsg('새 비밀번호가 일치하지 않습니다');
    if (pwForm.next.length < 6) return setPwMsg('비밀번호는 6자 이상이어야 합니다');
    setLoading(true);
    try {
      await client.post('/auth/change-password', { current_password: pwForm.current, new_password: pwForm.next });
      setPwMsg('✅ 비밀번호가 변경되었습니다');
      setPwForm({ current: '', next: '', confirm: '' });
    } catch (e: any) { setPwMsg(e.response?.data?.detail || '변경 실패'); }
    finally { setLoading(false); }
  };

  const handleEmailSave = async () => {
    setLoading(true);
    try {
      await client.post('/auth/email-settings', emailSettings);
      setEmailMsg('✅ 저장되었습니다');
      setTimeout(() => setEmailMsg(''), 2000);
    } catch { setEmailMsg('저장 실패'); }
    finally { setLoading(false); }
  };

  const handleWithdraw = async () => {
    if (!window.confirm('정말 탈퇴하시겠습니까?\n모든 데이터가 삭제되며 복구할 수 없습니다.')) return;
    if (!window.confirm('마지막으로 확인합니다. 정말 탈퇴하시겠습니까?')) return;
    try {
      await client.delete('/auth/withdraw');
      localStorage.clear(); sessionStorage.clear();
      navigate('/');
    } catch { alert('탈퇴 처리 실패'); }
  };

  const s: any = {
    card: { background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 8, padding: 20, marginBottom: 12 },
    input: { width: '100%', background: '#0F1117', border: '0.5px solid #2A3045', borderRadius: 8, padding: '10px 12px', color: '#E8ECF4', fontSize: 14, boxSizing: 'border-box' as const, marginBottom: 12 },
    btn: { background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 24px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
    btnRed: { background: 'none', border: '1px solid #F56565', borderRadius: 8, padding: '10px 24px', color: '#F56565', fontSize: 14, cursor: 'pointer' },
    tab: (active: boolean) => ({ background: active ? '#1A2035' : 'none', border: active ? '0.5px solid #00D4AA' : '0.5px solid #2A3045', borderRadius: 6, padding: '7px 20px', color: active ? '#00D4AA' : '#8892A4', fontSize: 13, cursor: 'pointer', fontWeight: active ? 700 : 400 }),
    label: { color: '#8892A4', fontSize: 12, marginBottom: 6, display: 'block' },
  };

  const Toggle = ({ val, onChange }: { val: boolean; onChange: () => void }) => (
    <div onClick={onChange} style={{ width: 44, height: 24, borderRadius: 12, background: val ? '#00D4AA' : '#2A3045', position: 'relative' as const, cursor: 'pointer', transition: 'background 0.2s', flexShrink: 0 }}>
      <div style={{ position: 'absolute' as const, top: 2, left: val ? 22 : 2, width: 20, height: 20, borderRadius: 10, background: 'white', transition: 'left 0.2s' }} />
    </div>
  );

  return (
    <Layout>
      <div style={{ maxWidth: 700 }}>
        <div style={{ marginBottom: 20 }}>
          <h2 style={{ color: '#E8ECF4', fontSize: 18, fontWeight: 700, margin: '0 0 4px' }}>마이페이지</h2>
          <p style={{ color: '#8892A4', fontSize: 12, margin: 0 }}>{user.email}</p>
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' as const }}>
          <button style={s.tab(tab === 'plan')} onClick={() => setTab('plan')}>플랜 현황</button>
          <button style={s.tab(tab === 'password')} onClick={() => setTab('password')}>비밀번호 변경</button>
          <button style={s.tab(tab === 'email')} onClick={() => setTab('email')}>이메일 수신 설정</button>
          <button style={s.tab(tab === 'withdraw')} onClick={() => setTab('withdraw')}>회원 탈퇴</button>
        </div>

        {tab === 'plan' && (
          <>
            <div style={{ ...s.card, background: 'linear-gradient(135deg, #0F2A22, #0D1F35)', border: '0.5px solid #00D4AA33' }}>
              <div style={{ color: '#8892A4', fontSize: 12, marginBottom: 8 }}>현재 플랜</div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' as const, gap: 12 }}>
                <div>
                  <div style={{ color: PLAN_COLOR[user.plan] || '#8892A4', fontSize: 28, fontWeight: 800, textTransform: 'uppercase' as const }}>{user.plan || 'free'}</div>
                  <div style={{ color: '#8892A4', fontSize: 13, marginTop: 4 }}>{PLAN_PRICE[user.plan] || '무료'}</div>
                </div>
                <button onClick={() => navigate('/pricing')} style={s.btn}>플랜 업그레이드</button>
              </div>
            </div>
            <div style={s.card}>
              <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600, marginBottom: 16 }}>현재 플랜 혜택</div>
              {[
                { label: '쇼핑 순위 조회', free: '1회/시간', basic: '5회/시간', pro: '10회/시간' },
                { label: '추적 상품 수', free: '3개', basic: '5개', pro: '10개' },
                { label: '플레이스 등록', free: '1개', basic: '2개', pro: '5개' },
                { label: '키워드 검색량', free: '5회/일', basic: '10회/일', pro: '무제한' },
                { label: '자동 이메일 발송', free: '❌', basic: '✅', pro: '✅' },
                { label: '동시 접속', free: '1기기', basic: '3기기', pro: '5기기' },
              ].map(item => (
                <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '0.5px solid #1E2535' }}>
                  <span style={{ color: '#8892A4', fontSize: 13 }}>{item.label}</span>
                  <span style={{ color: '#E8ECF4', fontSize: 13, fontWeight: 600 }}>{(item as any)[user.plan || 'free'] || item.free}</span>
                </div>
              ))}
            </div>
            {user.plan !== 'free' && (
              <div style={s.card}>
                <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600, marginBottom: 12 }}>구독 관리</div>
                {subStatus?.status === 'cancelled' ? (
                  <div style={{ background: '#1A1500', border: '0.5px solid #F6AD5544', borderRadius: 8, padding: '14px 16px', marginBottom: 12 }}>
                    <div style={{ color: '#F6AD55', fontSize: 13, fontWeight: 700, marginBottom: 4 }}>⚠️ 구독 취소됨</div>
                    <div style={{ color: '#8892A4', fontSize: 13, lineHeight: 1.8 }}>
                      {subStatus?.expires_at ? new Date(subStatus.expires_at).toLocaleDateString('ko-KR') : ''} 까지 이용 가능합니다.<br />
                      이후 자동 결제가 진행되지 않으며 Free 플랜으로 전환됩니다.
                    </div>
                    <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' as const }}>
                      <button onClick={async () => {
                        if (!window.confirm('구독을 재활성화하시겠습니까?\n기존 만료일 이후 자동 갱신됩니다.')) return;
                        try {
                          const r = await client.post('/payment/billing/reactivate');
                          alert(r.data.message);
                          window.location.reload();
                        } catch (e: any) { alert(e.response?.data?.detail || '재활성화 실패'); }
                      }} style={s.btn}>구독 재활성화</button>
                      <button onClick={() => navigate('/pricing')} style={{ ...s.btn, background: '#378ADD' }}>플랜 변경</button>
                    </div>
                  </div>
                ) : (
                  <>
                    {subStatus && (
                      <div style={{ background: '#0F1117', borderRadius: 8, padding: '12px 14px', marginBottom: 12, fontSize: 13 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                          <span style={{ color: '#8892A4' }}>결제 유형</span>
                          <span style={{ color: '#E8ECF4' }}>{subStatus.billing_type === 'monthly' ? '월간 구독' : '연간 구독'}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                          <span style={{ color: '#8892A4' }}>다음 결제일</span>
                          <span style={{ color: '#E8ECF4' }}>{subStatus.next_billing_at ? new Date(subStatus.next_billing_at).toLocaleDateString('ko-KR') : '-'}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ color: '#8892A4' }}>결제 금액</span>
                          <span style={{ color: '#E8ECF4' }}>{subStatus.amount?.toLocaleString()}원</span>
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: 12 }}>
                      <button onClick={() => navigate('/pricing')} style={s.btn}>플랜 변경</button>
                      <button style={s.btnRed} onClick={async () => {
                        if (!window.confirm('구독을 취소하시겠습니까?\n현재 결제 기간 만료일까지 이용 가능합니다.')) return;
                        try {
                          const r = await client.post('/payment/billing/cancel', { cancel_reason: '사용자 요청' });
                          alert(r.data.message);
                          window.location.reload();
                        } catch (e: any) { alert(e.response?.data?.detail || '취소 실패'); }
                      }}>구독 취소</button>
                    </div>
                    <p style={{ color: '#4A5568', fontSize: 12, marginTop: 12 }}>구독 취소 시 현재 결제 기간 만료일까지 정상 이용 가능합니다.</p>
                  </>
                )}
              </div>
            )}
          </>
        )}

        {tab === 'password' && (
          <div style={s.card}>
            <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600, marginBottom: 16 }}>비밀번호 변경</div>
            <label style={s.label}>현재 비밀번호</label>
            <input type="password" style={s.input} value={pwForm.current} onChange={e => setPwForm({...pwForm, current: e.target.value})} />
            <label style={s.label}>새 비밀번호</label>
            <input type="password" style={s.input} value={pwForm.next} onChange={e => setPwForm({...pwForm, next: e.target.value})} />
            <label style={s.label}>새 비밀번호 확인</label>
            <input type="password" style={s.input} value={pwForm.confirm} onChange={e => setPwForm({...pwForm, confirm: e.target.value})} />
            {pwMsg && <p style={{ color: pwMsg.includes('✅') ? '#00D4AA' : '#F56565', fontSize: 13, marginBottom: 12 }}>{pwMsg}</p>}
            <button style={s.btn} onClick={handlePwChange} disabled={loading}>비밀번호 변경</button>
          </div>
        )}

        {tab === 'email' && (
          <div style={s.card}>
            <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600, marginBottom: 16 }}>이메일 수신 설정</div>
            {[
              { key: 'email_rank_report', label: '순위 변동 리포트', desc: '매일 오전 8시 쇼핑/플레이스 순위 변동 이메일' },
              { key: 'email_notice', label: '공지사항 알림', desc: '서비스 업데이트, 점검 안내 등 중요 공지' },
            ].map(item => (
              <div key={item.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 0', borderBottom: '0.5px solid #1E2535' }}>
                <div>
                  <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600 }}>{item.label}</div>
                  <div style={{ color: '#4A5568', fontSize: 12, marginTop: 2 }}>{item.desc}</div>
                </div>
                <Toggle val={(emailSettings as any)[item.key]} onChange={() => setEmailSettings(prev => ({...prev, [item.key]: !(prev as any)[item.key]}))} />
              </div>
            ))}
            <div style={{ marginTop: 16 }}>
              {emailMsg && <p style={{ color: '#00D4AA', fontSize: 13, marginBottom: 8 }}>{emailMsg}</p>}
              <button style={s.btn} onClick={handleEmailSave} disabled={loading}>저장</button>
            </div>
          </div>
        )}

        {tab === 'withdraw' && (
          <div style={s.card}>
            <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 600, marginBottom: 12 }}>회원 탈퇴</div>
            <div style={{ background: '#2A0D0D', border: '1px solid #F5656533', borderRadius: 8, padding: 16, marginBottom: 16 }}>
              <div style={{ color: '#F56565', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>⚠️ 탈퇴 전 꼭 확인하세요</div>
              <ul style={{ color: '#8892A4', fontSize: 12, paddingLeft: 16, lineHeight: 2, margin: 0 }}>
                <li>모든 데이터(순위 추적, 키워드 분석, 전략 등)가 삭제됩니다</li>
                <li>삭제된 데이터는 복구할 수 없습니다</li>
                <li>유료 구독 중인 경우 환불은 고객센터로 문의해주세요</li>
              </ul>
            </div>
            <button style={s.btnRed} onClick={handleWithdraw}>회원 탈퇴</button>
          </div>
        )}
      </div>
    </Layout>
  );
}
